var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Modal, ModalContent } from '@/components/ui/Modal/Modal';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
/**
 * 見出し付きのモーダル
 * @param props
 * @returns
 */
export const ModalWithTitle = (props) => {
    const { children, className = '', contentClassName = '', headText } = props, modalProps = __rest(props, ["children", "className", "contentClassName", "headText"]);
    return (_jsxs(Modal, Object.assign({}, modalProps, { className: className }, { children: [_jsx(BandHead, Object.assign({ bgColor: 'gray', fixTextPosition: 'center' }, { children: headText })), _jsx(ModalContent, Object.assign({ contentClassName: contentClassName }, { children: children }))] })));
};
